import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataBreach } from 'it/primatoo/openapi/api/org/schemas/databreachprocess/DataBreach';
import { FormControl, FormGroup } from '@angular/forms';
import { DataBreachProcessService } from '@pt/api-client';
import { UpdateDataBreachRequest } from 'it/primatoo/openapi/api/org/schemas/databreachprocess/UpdateDataBreachRequest';

@Component({
  selector: 'pt-update-data-breach-dialog',
  template: `
    <div class='modal-header'>
      <h4 class='modal-title'>
        {{ databreach?.name }}
      </h4>
    </div>

    <div class='modal-body'>
      <form [formGroup]="formGroup">
        <pt-input-checkbox
          [controlName]='"notifyIncTeam"'
          formControlName='notifyIncTeam'
          [label]="('DB_EDITOR.SEND_INCIDENT_TEAM_NOTIFICATION') | translate"
        ></pt-input-checkbox>
        <pt-input-checkbox
          [controlName]='"close"'
          formControlName='close'
          [label]="('DB_EDITOR.CLOSE_INCIDENT') | translate"
        ></pt-input-checkbox>
      </form>
    </div>

    <div class='modal-footer'>
      <button type='button' class='btn btn-primary btn-sm'
              (click)='confirm(); $event.stopPropagation()'>
        {{ 'BUTTON.SAVE' | translate }}
      </button>
      <button type='button' class='btn btn-outline-secondary btn-sm'
              (click)='cancel(); $event.stopPropagation()'>
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
    </div>

  `,
  styles: [`
    .list-incident-team {
      list-style-type: none;
      max-height: 150px;
      overflow-y: auto;
    }

    .list-incident-team::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }

    .list-incident-team::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    .list-incident-team::-webkit-scrollbar-thumb {
      background: #888;
    }

    .list-incident-team::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  `]
})
export class UpdateDataBreachDialogComponent {
  public databreach: DataBreach;

  public formGroup: FormGroup = new FormGroup({
    close: new FormControl(false),
    notifyIncTeam: new FormControl(false)
  })
  public canCloseValue: boolean;

  constructor(public activeModal: NgbActiveModal, private databreachService: DataBreachProcessService) {
    this.formGroup.disable();

  }

  run(databreach: DataBreach, request: UpdateDataBreachRequest): void {
    this.databreach = databreach;
    this.databreachService.canClose(request).subscribe((response: { closable: boolean }) => {
      this.canCloseValue = response.closable;
      this.canClose(response.closable);
    }, (fail) => {
      this.canClose(false);
    })
  }

  private canClose(canClose: boolean) {
    if (canClose) {
      this.formGroup.controls.close.enable();
      this.formGroup.controls.notifyIncTeam.enable();
    } else {
      this.formGroup.controls.close.disable();
      this.formGroup.controls.notifyIncTeam.enable();
    }
  }

  confirm() {
    const response: UpdateDataBreachDialogResponse = {
      notifyIncTeam: this.formGroup.controls.notifyIncTeam.value,
      close: this.formGroup.controls.close.value
    };
    this.activeModal.close(response);
  }

  cancel() {
    this.activeModal.close(null);
  }
}

export interface UpdateDataBreachDialogResponse {
  close: boolean;
  notifyIncTeam: boolean;
}
